import { Router } from '@lightningjs/sdk'

import { VerticalPointerSize } from '../components/NavigationPointers/NavigationPointers'
import { AppConfig } from '../services/appConfig'
import { TvBrowseLayoutModel } from '../types/flo-experience'
import { getText } from '../utils/dictionary'
import { networkError } from '../widgets/modal'
import CarouselsHandler from './handlers/carouselsHandler'

export default class FavoriteHub extends CarouselsHandler {
  private _data: TvBrowseLayoutModel

  _init() {
    this.tvBrowseLayout.isFavoriteHub = true
    this.navigationPointers.verticalPointerSize = VerticalPointerSize.MINI
  }

  async _onUrlParams(args) {
    this._setState('NotReady')

    await this.getFavoriteHubData(args.url)
  }

  get pageText() {
    return 'Favorite Hub'
  }

  async getFavoriteHubData(url) {
    const data = await AppConfig.shared.experienceApi.getFavoriteHub(url)

    if (data?.error) {
      const favoritesError = {
        title: getText('genericErrorTitle'),
        info: getText('pageNotFoundText'),
        buttons: [
          {
            label: getText('close'),
            isDefaultBackAction: true,
            callback: () => {
              Router.back()
              this.widgets.menu.visible = true
            },
          },
        ],
      }
      const error = data.isNetworkError ? networkError : favoritesError
      this.setModal(true, error)
      this.widgets.menu.visible = false
      return
    }

    this._data = data
    this._data.container.items =
      this._lastCarousels.length > 0 ? this._lastCarousels : this._data.container.items
    this.tvBrowseLayout.data = this._data
    this.tvBrowseLayout.spotlight.entityType = this._data?.analytics?.entity_type
    this.tvBrowseLayout.spotlight.renderSpotlightData({ spotlight_metadata: this._data.spotlight })

    this.restoreFocus()

    this._setState('Ready')
  }

  $fireAuthRequired(authReason: string) {
    this.widgets.authrequired.authReason = authReason
    this.widgets.authrequired.visible = true
    ;(Router.getActivePage() as any)._setState('InBackgroundByModal')
    Router.focusWidget('AuthRequired')
  }
}
